module.exports = __webpack_public_path__ + "img/coin-use-1.5a3c5d37.jpg";